import { render, staticRenderFns } from "./StockScoreDetailsTotal.vue?vue&type=template&id=56caa795&scoped=true&"
import script from "./StockScoreDetailsTotal.vue?vue&type=script&lang=js&"
export * from "./StockScoreDetailsTotal.vue?vue&type=script&lang=js&"
import style0 from "./StockScoreDetailsTotal.vue?vue&type=style&index=0&id=56caa795&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56caa795",
  null
  
)

export default component.exports